<template>
  <DashboardHeader :title="'Manage ' + getCompanyLabels.matter + 's'">
    <div>
      <v-layout row wrap>
        <v-flex md3 sm12 class="ml-6 mb-2">
          <VirtualScrollCase
            class="mt-4 mb-8"
            :title="
              selectedCase
                ? selectedCase.title
                : 'Select ' + getCompanyLabels.matter
            "
          >
            <template #content>
              <SelectCase
                :label="'Search ' + getCompanyLabels.matter + 's'"
                @case-selected="getSelectedCase"
              ></SelectCase>

              <CardAlert
                class="mt-2"
                v-if="isStaff && selectedCase"
                color="#3E2723"
              >
                Total Billed: {{ getCurrency }}{{ selectedCase.totalBillings }}
              </CardAlert>

              <CardAlert
                class="mt-2"
                v-if="isStaff && selectedCase"
                color="#E65100"
              >
                Total Invoiced: {{ getCurrency
                }}{{ selectedCase.totalInvoices }}
              </CardAlert>

              <CardAlert
                class="mt-2"
                v-if="isStaff && selectedCase"
                color="#1B5E20"
              >
                Total Paid: {{ getCurrency }}{{ selectedCase.totalPayments }}
              </CardAlert>

              <CardAlert
                class="mt-2"
                v-if="isStaff && selectedCase"
                color="#DD2C00"
              >
                Total Outstanding: {{ getCurrency
                }}{{ selectedCase.totalOutstandings }}
              </CardAlert>
              <CardAlert
                class="mt-2 mb-16"
                v-if="isStaff && selectedCase"
                :color="selectedCase.status.color"
              >
                Status: {{ selectedCase.status.name }}
              </CardAlert>
            </template>
          </VirtualScrollCase>
        </v-flex>
        <v-flex md8 sm12>
          <v-tabs
            v-model="tab"
            align-with-title
            v-if="selectedCase"
            show-arrows
            height="64"
            class="mt-4 mx-4"
          >
            <v-tabs-slider color="yellow"></v-tabs-slider>
            <v-tab v-for="item in tabHeaders" :key="item">
              {{
                item == "Details" || item == "Tasks"
                  ? getCompanyLabels.matter + " " + item
                  : item
              }}
            </v-tab>
          </v-tabs>

          <v-card class="mt-2">
            <v-tabs-items v-model="tab">
              <v-tab-item
                v-for="(item, ind) in tabHeaders"
                :key="ind + Math.random()"
              >
                <v-card v-if="item.includes('Details')">
                  <CaseDetail
                    :selCase="selectedCase"
                    class="mt-n8 mb-n4"
                    @refresh-needed="refreshCaseDetailsAfterUpdate"
                  ></CaseDetail>
                </v-card>

                <v-card v-else-if="item.includes('Task')">
                  <Tasks :selectedCase="selectedCase"></Tasks>
                </v-card>

                <v-card v-else-if="item.includes('Invoicing')">
                  <BillingDashboard
                    v-if="selectedCase"
                    :selCase="selectedCase"
                    @refresh-needed="refreshCaseDetails"
                  ></BillingDashboard>
                </v-card>
                <v-card v-else-if="item.includes('Manage Invoices')">
                  <InvoiceTable
                    v-if="selectedCase"
                    :invoices="invoices"
                    @refresh-needed="refreshCaseDetails"
                  ></InvoiceTable>
                </v-card>

                <v-card v-else-if="item.includes('Notes')">
                  <Notes
                    :selectedCase="selectedCase"
                    @refresh-needed="refreshCaseDetails"
                  ></Notes>
                </v-card>

                <v-card v-else-if="item.includes('Client')">
                  <ClientDetail
                    class="mb-14"
                    v-if="selectedCase && selectedCase.client"
                    :client="selectedCase.client"
                  ></ClientDetail>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>

          <GlobalDialogSlot
            :title="'Add ' + getCompanyLabels.matter"
            :dialog="dialog"
            @close-dialog="closeDialog"
          >
            <AddCase
              v-if="addCase"
              :client="selectedCase ? selectedCase.client : null"
              @close-case-dialog="closeDialog"
              @case-added="getAddedCase"
            ></AddCase>
          </GlobalDialogSlot>
        </v-flex>

        <FabButton
          marginTop="mt-8"
          @button-clicked="openAddCaseDialog"
        ></FabButton>
      </v-layout>
    </div>
  </DashboardHeader>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";
import SelectCase from "@/components/Cases/SelectCase.vue";
import AddCase from "@/components/Cases/AddCase.vue";
import CaseDetail from "@/components/Cases/CaseDetail.vue";
import BillingDashboard from "@/components/Billings/BillingDashboard.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";
import Notes from "@/components/Note/Note.vue";
import Tasks from "@/components/Task/Task.vue";
import VirtualScrollCase from "@/components/myLibrary/VirtualScrollCase.vue";
import CardAlert from "@/components/myLibrary/CardAlert.vue";
import FabButton from "@/components/myLibrary/FabButton.vue";
import ClientDetail from "@/components/Clients/ClientDetail.vue";
import InvoiceTable from "@/components/InvoicesAndQuotes/InvoiceTable.vue";

export default {
  name: "ManageCases",
  components: {
    CardAlert,
    DashboardHeader,
    SelectCase,
    AddCase,
    CaseDetail,
    BillingDashboard,
    GlobalDialogSlot,
    Tasks,
    Notes,
    VirtualScrollCase,
    FabButton,
    ClientDetail,
    InvoiceTable,
  },

  computed: {
    dateCaptured() {
      if (
        this.selectedCase.date_captured == "N/A" ||
        this.selectedCase.date_captured == "not determined" ||
        this.selectedCase.date_captured == null
      ) {
        const date = new Date();
        return new Date(date.setDate(date.getDate() + 60))
          .toISOString()
          .substr(0, 10);
      } else {
        return this.selectedCase.date_captured;
      }
    },
    dateStarted() {
      if (
        this.selectedCase.start_date == "N/A" ||
        this.selectedCase.start_date == "not determined" ||
        this.selectedCase.start_date == null
      ) {
        const date = new Date();
        return new Date(date.setDate(date.getDate() + 60))
          .toISOString()
          .substr(0, 10);
      } else {
        return this.selectedCase.start_date.toISOString().substr(0, 10);
      }
    },
    dateEnded() {
      if (
        this.selectedCase.end_date == "N/A" ||
        this.selectedCase.end_date == "not determined" ||
        this.selectedCase.end_date == null
      ) {
        const date = new Date();
        return new Date(date.setDate(date.getDate() + 60))
          .toISOString()
          .substr(0, 10);
      } else {
        return this.selectedCase.end_date;
      }
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },

    computedclientProfile() {
      return this.clientProfile;
    },
  },
  mounted() {
    if (this.$route.params.caseObj) {
      this.selectedCase = this.$route.params.caseObj;
      this.selectedCaseReference = this.$route.params.caseObj.id;
      this.cases = [];
      this.cases.push({
        text: `${this.$route.params.caseObj.title} | ${this.$route.params.caseObj.file_number} | ${this.$route.params.caseObj.client_reference}`,
        value: this.$route.params.caseObj.id,
      });
    }
  },

  data() {
    return {
      tabHeaders: [
        "Details",
        "Client",
        "Notes & Billings",
        "Billings & Invoicing",
        "Manage Invoices",
        "Tasks",
      ],
      tab: "Matter Details",
      addCase: false,
      cases: [],
      dialog: false,
      selectedCaseReference: null,
      selectedCase: null,
      invoices: [],
    };
  },
  methods: {
    fetchCaseWithID(caseID) {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-selected-case",
          { selectedCaseID: caseID },
          this.getAccessToken
        )
        .then((selectedCase) => {
          this.selectedCase = selectedCase;
          axios
            .postDataWithToken(
              "/auth/get-invoices-selected-data",
              { caseID: selectedCase.id },
              this.getAccessToken
            )
            .then((invoices) => {
              this.invoices = invoices;
              this.$store.commit("setLoader", false);
            });
        });
    },
    refreshCaseDetailsAfterUpdate(caseID) {
      this.fetchCaseWithID(caseID);
    },
    getSelectedCase(selectedCaseReference) {
      this.selectedCaseReference = selectedCaseReference;
      this.fetchCaseWithID(selectedCaseReference);
    },
    refreshCaseDetails() {
      this.fetchCaseWithID(this.selectedCaseReference);
    },
    openAddCaseDialog() {
      this.dialog = true;
      this.addCase = true;
    },
    closeDialog() {
      this.dialog = false;
      this.addCase = false;
    },
    getAddedCase(caseObj) {
      this.cases.push({
        text: `${caseObj.title} [ ${caseObj.client_reference} ]`,
        value: caseObj.id,
      });
      this.closeDialog();
      this.fetchCaseWithID(caseObj.id);
    },
  },
};
</script>

<style></style>
